import { JobTitle } from '../api/job-titles'
import { AvailableWorker, User } from '../api/users'
import { WorkersRequest, WorkersRequestPost } from '../api/workers-requests'
import { compareDocsById } from './documents'

export const getInterimAgencySettingsFromPost = (
  post: WorkersRequestPost,
  workersRequest: WorkersRequest,
): JobTitle['interimAgencySettings'][0] | undefined => {
  return post.jobTitle.interimAgencySettings.find(setting =>
    compareDocsById(setting.interimAgency, workersRequest.interimAgency),
  )
}

export const getMustAddCustomHourlyCost = (
  post: WorkersRequestPost,
  workersRequest: WorkersRequest,
) => {
  const interimAgencySettings = getInterimAgencySettingsFromPost(post, workersRequest)
  return !interimAgencySettings?.hourlyRateSettings.useSmic
}

export const isAvailableWorker = (
  worker: User | AvailableWorker,
  availableWorkers: AvailableWorker[],
): boolean => {
  return availableWorkers.some(availableWorker => compareDocsById(availableWorker, worker))
}
